import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  Button,
} from "./SidebarElements";

const Sidebar2 = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink
            to="/?scrollTo=about"
            onClick={toggle} 
            >
            Why
          </SidebarLink>
          <SidebarLink to="/?scrollTo=discover" onClick={toggle}>
            What
          </SidebarLink>
          <SidebarLink to="/?scrollTo=retreat" onClick={toggle}>
            Retreats
          </SidebarLink>
          <SidebarLink to="/?scrollTo=services" onClick={toggle}>
            How
          </SidebarLink>
          <SidebarLink to="/?scrollTo=where" onClick={toggle}>
            Where
          </SidebarLink>
          <SidebarLink to="/?scrollTo=contact" onClick={toggle}>
            Contact
          </SidebarLink>
          <SidebarLink as="div">
            <Button
              onClick={() =>
                window.open(
                  "https://www.youtube-nocookie.com/embed/OTCD5fQI8q8?autoplay=1&mute=1",
                  "_blank",
                  "fullscreen=yes"
                )
              }
            >
              Switch Off
            </Button>
          </SidebarLink>
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar2;
